export default __webpack_public_path__ + "static/media/FotoSeg6.f46e1904.png";